import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {ActivationEnd, NavigationEnd, Router} from '@angular/router';
import {AuthComponent} from 'projects/paid/src/app/components/auth/auth.component';
import {AuthService} from 'projects/firebase/src/lib/services/auth.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {environment} from '../../environments/environment';
import {DataService} from 'projects/firebase/src/lib/services/data.service';
import {ConfirmSignInComponent} from 'projects/paid/src/app/components/auth/confirm-sign-in/confirm-sign-in.component';
import {FlowTypeService} from '../../../../shared/src/lib/services/flow-type.service';
import {PayedService} from '../services/payed.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {FeaturesService} from '../../../../shared/src/lib/services/features.service';
import {LanguageService} from '../services/language.service';

@Component({
    selector: 'app-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit {
    testName = 'anxiety';
    isProd = environment.isProd;
    v = environment.appVersion;
    isHomePage = false;
    isForBusiness = false;


    latestResultId = null;
    isAiSubscription = false;
    isAiChat = false;

    showStartTestButton = false;
    showAiStartTestButton = false;
    currentPosition = window.scrollY;
    apiUrl = environment.apiUrl;


    showNav = false;
    @ViewChild('header') header: ElementRef;

    @HostListener('window:scroll', ['$event.target']) // for window scroll events
    scroll(e) {
        const scroll = e.scrollingElement.scrollTop;
        if (scroll > 35) {
            e.getElementsByTagName('app-nav')[0].classList.add('scroll');
        } else {
            e.getElementsByTagName('app-nav')[0].classList.remove('scroll');
        }
        this.currentPosition = scroll;
    }

    constructor(
        public auth: AuthService,
        public data: DataService,
        private router: Router,
        private modalService: NgbModal,
        private flowTypeService: FlowTypeService,
        public payed: PayedService,
        private deviceService: DeviceDetectorService,
        public feature: FeaturesService,
        public languageService: LanguageService
    ) {
        router.events.subscribe((event: any) => {
            if (event instanceof NavigationEnd) {
                this.isHomePage = event.url === '/';
            }
            if (event instanceof ActivationEnd) {
                const showStart = event.snapshot?.firstChild?.firstChild?.firstChild?.data?.showStart;
                const showAiStart = event.snapshot?.firstChild?.firstChild?.firstChild?.data?.showAiStart;
                this.showStartTestButton = event.snapshot.data?.showStart || showStart;
                this.showAiStartTestButton = event.snapshot.data?.showAiStart || showAiStart;
                this.isForBusiness = event.snapshot.data?.showContactForDemo;
            }
        });
    }

    ngOnInit(): void {
        this.isAiChat = this.flowTypeService.state === 'ai';

        this.data.$latestResultId.subscribe((res) => {
            this.latestResultId = res;
        });
        const url = window.location.href;
        const email: any = window.localStorage.getItem('emailForSignIn');

        if (url.includes('login')) {
            if (!email) {
                this.openConfirmModal(url)
                    .then(() => {
                        this.confirmSignIn(email, url);
                    });
            } else {
                this.confirmSignIn(email, url);
            }
        }
    }

    get isMobile() {
        return this.deviceService.isMobile();
    }

    confirmSignIn(email, url) {
        this.auth.confirmSignIn(email, url)
            .then((res) => {
                if (res === 'auth/invalid-link') {
                    this.openAuthModal();
                }
            }, (err) => {
            });
    }

    get isLoggedIn(): boolean {
        return this.auth?.isLoggedIn;
    }

    openAuthModal(goToCs?: boolean) {
        const modalRef = this.modalService.open(AuthComponent, {
            centered: true,
            size: 'md',
            windowClass: 'modal login',
            backdrop: 'static',
            keyboard: true
        });
        modalRef.componentInstance.data = {};
        modalRef.result.then(
            (res: any) => {
                if (goToCs) {
                    this.goToTest();
                }
            },
            () => {
                // this.fetchLockedSlots();
            }
        );
    }

    openConfirmModal(url) {
        const modalRef = this.modalService.open(ConfirmSignInComponent, {
            centered: true,
            size: 'md',
            windowClass: 'modal login',
            backdrop: 'static',
            keyboard: true
        });
        modalRef.componentInstance.data = {};
        modalRef.componentInstance.url = url;

        return modalRef.result;
    }

    startTest() {
        if (this.isLoggedIn) {
            this.goToTest();
        } else {
            this.openAuthModal(true);
        }
    }

    goToTest() {
        return this.router.navigate(
            [!this.isAiChat || this.payed.isPayed() ? '/cs' : '/pricing'],
            {
                state: {
                    name: this.testName
                }
            });
    }

    onSignOut() {
        this.auth?.SignOut()
            .then();
    }

    goToResults(uid) {
        this.router.navigate(['s', uid, 'r'], {
            replaceUrl: true
        })
            .then((r) => {
            }, (e) => {
            });
    }
}
